import { getGlobalCookie } from '../utils';
import config from "../config";
import { useSelector, useDispatch } from "react-redux";
import { getPermissionsAc } from "../shared_elements/actionCreators";
export default function PrivateRoute({ children }) {
    const dispatch = useDispatch();
    const { permission } = useSelector((state) => state.leases);
    let lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'));

    
    if (lessorAccess) {
        if (Object.keys(permission).length && permission?.lessor?.id === lessorAccess.id) {
            return (<>{children}</>)
        } else {
            dispatch(getPermissionsAc({}, {
                permissions: [
                    "console",
                    "contracts",
                    "is_records",
                    "is_technical",
                    "is_camo",
                    "is_mr_calculator",
                    "is_valuation",
                    "lease_revamp"
                ]
            }))
        }
    } else {
        window.location.href = `${config.domain.subDomian}login?apps=lease-revamp`
    }
}